module.exports = __webpack_public_path__ + "img/msg05.98e1db10.png";